export function Calcular_Impuestos_Hasura(Travels) {
  let travelsWithCash = 0;
  let travelsWithCard = 0;
  let totalCard = 0;
  let totalCash = 0;
  let tarifa_iva = 0;
  let impuestos_isr = 0;
  let plataforma_iva = 0;
  let tarifa_comision = 0;
  let cuota_de_solicitud = 0;
  let CARD_tarifa_iva = 0;
  let CARD_impuestos_isr = 0;
  let CARD_plataforma_iva = 0;
  let CARD_tarifa_comision = 0;
  let CARD_cuota_de_solicitud = 0;

  for (let i in Travels) {
    if (Travels[i].payment_method === "Efectivo") {
      travelsWithCash = travelsWithCash + 1;
      totalCash = totalCash + Travels[i].pago_total;
      tarifa_iva = tarifa_iva + Travels[i].tarifa_iva;
      impuestos_isr = impuestos_isr + Travels[i].impuestos_isr;
      plataforma_iva = plataforma_iva + Travels[i].plataforma_iva;
      tarifa_comision = tarifa_comision + Travels[i].tarifa_comision;
      cuota_de_solicitud = cuota_de_solicitud + Travels[i].cuota_de_solicitud;
    } else {
      totalCard = totalCard + Travels[i].pago_total;
      travelsWithCard = travelsWithCard + 1;
      CARD_tarifa_iva = CARD_tarifa_iva + Travels[i].tarifa_iva;
      CARD_impuestos_isr = CARD_impuestos_isr + Travels[i].impuestos_isr;
      CARD_plataforma_iva = CARD_plataforma_iva + Travels[i].plataforma_iva;
      CARD_tarifa_comision = CARD_tarifa_comision + Travels[i].tarifa_comision;
      CARD_cuota_de_solicitud =
        CARD_cuota_de_solicitud + Travels[i].cuota_de_solicitud;
    }
  }

  let totalCashWithoutImp =
    totalCash -
    tarifa_iva -
    impuestos_isr -
    plataforma_iva -
    cuota_de_solicitud -
    tarifa_comision;

  let totalCardWithoutImp =
    totalCard -
    CARD_tarifa_iva -
    CARD_impuestos_isr -
    CARD_plataforma_iva -
    CARD_cuota_de_solicitud -
    CARD_tarifa_comision;

  const infoTravels = {
    travelsWithCash,
    travelsWithCard,
    totalCard,
    totalCash,
    tarifa_iva,
    impuestos_isr,
    plataforma_iva,
    tarifa_comision,
    cuota_de_solicitud,
    totalCashWithoutImp,
    /* EFECTIVO */
    CARD_tarifa_iva,
    CARD_impuestos_isr,
    CARD_plataforma_iva,
    CARD_tarifa_comision,
    CARD_cuota_de_solicitud,
    totalCardWithoutImp,
  };
  return infoTravels;
}
